import TemplateWeeks from 'modules/shift_management/store/internal/collections/TemplateWeeks'

export type TemplateWeeksState = TemplateWeeks

export type TemplateWeeksDispatch = (arg0: TemplateWeeksAction) => void

export type TemplateWeeksAction = {
  type: 'BOOTSTRAP'
  templateWeeks: TemplateWeeks | undefined
}

export function initialTemplateWeeksState(): TemplateWeeksState {
  return new TemplateWeeks([])
}

export default function reducer(
  state: TemplateWeeksState,
  action: TemplateWeeksAction
): TemplateWeeksState {
  switch (action.type) {
    case 'BOOTSTRAP': {
      if (!!action.templateWeeks) {
        return action.templateWeeks
      }
      return state
    }
    default:
      return state
  }
}
